"use strict";

var Backbone                            = require("backbone");
var _                                   = require("underscore");
var $                                   = require("jquery");
Backbone.$ = $;

var debug                               = require("debug")("views:OverlayAnnotationsView");

var AnnotationView                      = require("../views/annotation-view");

/**
 * overlay pour la pose et l'affichage des annotations
 * Trigger:
 */
module.exports=Backbone.View.extend({

    className:"overlay overlay-annotations",
    annotationCollection:null,  // AnnotationCollection
    pageModel:null,             // PageModel
    page:0,

    events:{
       "pointerdown":"onDragStart"
    },

    initialize:function(options){
        var T=this;
        
        T._pointers={};
        T._dragStartPoint={x:0,y:0};
        T._dragStartSelection={};
        T._abortDrag=false;

        _.extend(T, options);

        if(T.active){
            T.$el.addClass("active");
        }

        T.listenTo(T.pageModel,"sync",T.render);
        
        T.listenTo(T.annotationCollection, "add", T.addOne);
        T.listenTo(T.annotationCollection, "reset", T.addAll);

        T.render();
    },

    render:function(){
        var T=this;
       
        T.$el.html("");

        if(T.pageModel.fetched){
           debug("render annotations page %d",T.page);

           T.addAll();
          
        }
    },

    addOne: function( annotation ) {
        var T=this;
        if(annotation.get("page")==T.page){
            var view=new AnnotationView({ 
                model: annotation,
                app:T.app
            });
            view.render();
            T.listenTo(view,"click",T.onAnnotationClicked);
            T.$el.append(view.el);
        }
    },
    
    addAll: function() {
        var T = this;
        T.$el.html("");
        T.annotationCollection.each(T.addOne,T);
    },

    onAnnotationClicked:function(annotation_model){
        this.trigger("click:annotation",annotation_model);
    },

    onDragStart:function(e){
        var T=this;
        
        if(!T.$el.hasClass("active")){
            return;
        }

        T._pointers[e.originalEvent.pointerId]={
            pageX:e.pageX,
            pageY:e.pageY
        };

        var keys=_.keys(T._pointers);

        if(keys.length==1){
            T.dragStartDate=Date.now();
            T._dragStartPoint.x=e.pageX;
            T._dragStartPoint.y=e.pageY;
            $(window).on("pointerup.ov-annot",function(e){T.onDragEnd(e);});
            $(window).on("pointermove.ov-annot",function(e){T.onDragMove(e);});
            $(window).on("pointercancel.ov-annot",function(e){T.onDragEnd(e);});
        }
        else{
            T._abortDrag=true;
        }
    },

    onDragMove:function(e){ //jshint ignore: line
        var T=this;

        if(T._abortDrag)return;

        //console.log("drag move doc "+e.type);
        T._pointers[e.originalEvent.pointerId]={
            pageX:e.pageX,
            pageY:e.pageY
        };
    },

    onDragEnd:function(e){
        var T=this;

        if(!T.$el.hasClass("active")){
            return;
        }

        var last_x=T._pointers[e.originalEvent.pointerId].pageX;
        var last_y=T._pointers[e.originalEvent.pointerId].pageY;

        delete T._pointers[e.originalEvent.pointerId];

        var keys=_.keys(T._pointers);

        //console.log("drag end doc "+e.type);
        if(!keys.length){
            $(window).off(".ov-annot");
            T._abortDrag=false;

            if(Date.now()-T.dragStartDate<400 && Math.abs(last_x-T._dragStartPoint.x)<3&& Math.abs(last_y-T._dragStartPoint.y)<3){
                // c'est un click
                var new_x=((T._dragStartPoint.x-T.$el.offset().left)*100)/T.$el.parent().width();
                var new_y=((T._dragStartPoint.y-T.$el.offset().top)*100)/T.$el.parent().height();

                var new_model=T.annotationCollection.create({
                    publicationId:T.pageModel.get("publicationId"),
                    documentId:T.pageModel.get("documentId"),
                    page:T.pageModel.get("id"),
                    left:new_x,
                    top:new_y
                },{
                    error: function(){ 
                        T.app.notify({
                            text:STR.unable_to_save,
                            type:"error",
                            timeout:4000
                        });
                    }
                });

                T.onAnnotationClicked(new_model);
            }
            else{
                //sinon c'est un drag de la page entière
            }
        }
    },
    

    close:function(){
        var T=this;
        T.annotationCollection=null;
        T.stopListening();
        T.undelegateEvents();
    }
});